import { GlobalOnexConfig } from './libs/onex/src'

export const config: GlobalOnexConfig = {
  active: true,
  id: 'E3547',
  smoketestsIncludeOnex: true,
  localE2eTestsIncludeOnex: {
    runVisualE2eTests: false,
    runFunctionalE2eTests: false,
  },
  activeOnexConfig: {
    StatusQuo: {
      template: 'cookieBanner-onetrust.html',
      styleFile: 'styles-onetrust.scss',
      onetrustVariantId: '01975f31-3941-7fad-9d5a-3d121fbd045a',
    },
    NewConsB: {
      onetrustVariantId: '01975f31-3941-7cbb-a8be-a3bc9b9d59f2',
    }
  },
}
